// extracted by mini-css-extract-plugin
export default {"header":"H3_header__-1PWv"};